<template>
  <div class="active_table">
    <toolbar>
      <div class="search">
        <div class="label">排口名称：</div>
        <Select v-model="search.manualType" @on-change="handleManualTypeChange" style="width: 15em" placeholder="筛选排口"
          clearable>
          <Option v-for="(value, key) in  sortedData" :key="key" :value="key">{{ value }}</Option>
        </Select>
        <div class="label" style="margin-left: 10px;"> 监测日期：</div>
        <DatePicker type="daterange" placement="bottom-end" placeholder="选择日期" style="width: 200px;"
          @on-change="dateSelect($event)"></DatePicker>
        <i-button type="default" @click="searchFunc" style="margin-left: 1em;">搜索</i-button>
        <i-button type="default" @click="layOut" style="margin-left: 1em;">导出</i-button>
      </div>
      <div class="active">
        <i-button type="primary" @click="addData">添加</i-button>
        <i-button type="error" style="margin-left: 1em;">批量删除</i-button>
      </div>
    </toolbar>
    <div class="table">
      <i-table border :columns="table.columns" :data="table.data"></i-table>
      <Page :total="table.total" show-sizer @on-change="pageCurrentChange($event)"
        @on-page-size-change="pageSizeChange($event)" style="text-align:right;margin-top: 1em" />
      <Spin fix v-show="table.loading"></Spin>
    </div>

    <!-- 表单对话框 -->
    <Modal :title="modal.title" v-model="modal.show" :mask-closable="false">
      <Form ref="formValidate" :model="formValidate" :rules="ruleValidate" :label-width="120">

        <FormItem label="选择排口：" prop="manualType">
          <Select v-model="formValidate.manualType" placeholder="选择排口" clearable>
            <Option v-for="(value, key) in  sortedDataFiltered" :key="key" :value="key">{{ value }}</Option>
          </Select>
        </FormItem>

        <FormItem label="监测日期：" prop="monitoringDate">
          <DatePicker type="date" placeholder="选择监测时间" v-model="formValidate.monitoringDate"></DatePicker>
        </FormItem>


        <!-- 根据计算属性动态显示/隐藏输入框 -->
        <FormItem v-for="item in visibleInputFields" :key="item" :label="getLabel(item)" :prop="item">
          <div class="form-row">
            <Select v-model="formValidate[item + 'ThanSign']" placeholder="选择比较运算符">
              <Option v-for="ts in ThanSignList" :key="ts.name" :value="ts.value">{{ ts.name }}</Option>
            </Select>
            <i-input v-model="formValidate[item]" :placeholder="getPlaceholder(item)"></i-input>
          </div>
        </FormItem>

        <FormItem label="备注信息：" prop="content">
          <i-input v-model="formValidate.content" type="textarea" :rows="2" placeholder="输入备注信息"></i-input>
        </FormItem>
      </Form>

      <div slot="footer">
        <i-button type="primary" @click="activeData">{{ modal.title }}</i-button>
        <i-button style="margin-left: 1em;" @click="modal.show = false">取消</i-button>
      </div>
    </Modal>

    <!-- 提示对话框 -->
    <alert-p :modalAlert="alert.show" title="警告提醒" content="确定要删除吗？" @cansel="alert.show = false" @makeSure="delData"
      :modal_loading="alert.loading"></alert-p>
  </div>
</template>

<style lang="scss" scoped>
.active_table {
  width: 100%;
  height: 100%;
}

.fh {
  margin: 5px 0px;
  background-color: #489ae1;
  color: #FFF;
  font-weight: bold;
  border-radius: 3px;
  padding: .3rem;
}

.table {
  padding: 0 1em;
  width: 100%;
  height: calc(100% - 7.5em);
  position: relative;
}

.ivu-table-border {
  border-color: #CCC;
}

.content {
  width: 700px;

  img {
    width: 100%;
  }
}

.form-row {
  display: flex;
  align-items: center;
}

.form-row Select,
.form-row i-input {
  margin-right: 10px;
  /* 可根据需要调整间距 */
}
</style>

<script>
import { BaseUrl } from '@/http/config.js';
import axios from 'axios';
import { timeStamp } from "../../../util/common/date";
import toolbar from "../toolBar.vue";

export default {
  data() {
    return {
      // 表格
      table: {
        // 表格属性
        columns: [
          {
            type: "selection",
            width: 60,
            align: "center",
          },
          {
            title: "监测日期",
            key: "monitoringDate",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  timeStamp(params.row.monitoringDate, "yyyy-MM-dd")
                ),
              ]);
            },
          },
          {
            title: "排口",
            key: 'manualType',
            width: 220,
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findManualTypeByName(params.row.manualType)
                ),
              ]);
            }
          },
          {
            title: "氟化物(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.fluorideThanSign) + this.getValue(params.row.fluoride)
                ),
              ]);
            }
          },
          {
            title: "颗粒物(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.pm10ThanSign) + this.getValue(params.row.pm10)
                ),
              ]);
            }
          },
          // {
          //   title: "烟尘(mg/m³)",
          //   align: "center",
          //   render: (h, params) => {
          //     return h("div", [
          //       h(
          //         "span",
          //         {},
          //         this.findThanSign(params.row.sdThanSign) + this.getValue(params.row.sd)
          //       ),
          //     ]);
          //   }
          // },
          {
            title: "铬酸雾(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.camThanSign) + this.getValue(params.row.cam)
                ),
              ]);
            }
          },
          {
            title: "非甲烷总烃(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.nmhcThanSign) + this.getValue(params.row.nmhc)
                ),
              ]);
            }
          },
          {
            title: "甲醛(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.hchoThanSign) + this.getValue(params.row.hcho)
                ),
              ]);
            }
          },
          {
            title: "苯酚(酚类化合物)(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.phenThanSign) + this.getValue(params.row.phen)
                ),
              ]);
            }
          },
          {
            title: "碱雾(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.amThanSign) + this.getValue(params.row.am)
                ),
              ]);
            }
          },
          {
            title: "臭气浓度(mg/m³)",
            align: "center",
            render: (h, params) => {
              return h("div", [
                h(
                  "span",
                  {},
                  this.findThanSign(params.row.odorThanSign) + this.getValue(params.row.odor)
                ),
              ]);
            }
          },
          {
            title: "备注",
            key: 'content',
            align: "center",
          },
          {
            title: "操作",
            align: "center",
            width: 150,
            render: (h, params) => {
              return h("div", [
                h(
                  "i-button",
                  {
                    props: {
                      type: "warning",
                      size: "small"
                    },
                    style: {
                      marginRight: "5px"
                    },
                    on: {
                      click: () => {
                        this.modal.title = "更新";
                        this.modal.show = true;
                        this.$refs.formValidate.resetFields(); // 清除验证错误
                        this.formValidate = {
                          id: params.row.id,
                          manualType: params.row.manualType,
                          fluoride: params.row.fluoride,
                          pm10: params.row.pm10,
                          sd: params.row.sd,
                          cam: params.row.cam,
                          nmhc: params.row.nmhc,
                          hcho: params.row.hcho,
                          phen: params.row.phen,
                          am: params.row.am,
                          odor: params.row.odor,
                          content: params.row.content,
                          monitoringDate: timeStamp(params.row.monitoringDate, "yyyy-MM-dd", true), // 监测时间
                          fluorideThanSign: (params.row.fluorideThanSign) || 0,
                          pm10ThanSign: (params.row.pm10ThanSign) || 0,
                          sdThanSign: (params.row.sdThanSign) || 0,
                          camThanSign: (params.row.camThanSign) || 0,
                          nmhcThanSign: (params.row.nmhcThanSign) || 0,
                          hchoThanSign: (params.row.hchoThanSign) || 0,
                          phenThanSign: (params.row.phenThanSign) || 0,
                          amThanSign: (params.row.amThanSign) || 0,
                          odorThanSign: (params.row.odorThanSign) || 0,
                          createDate: timeStamp(params.row.createDate, "yyyy-MM-dd", true),
                        };
                      }
                    }
                  },
                  "编辑"
                ),
                h(
                  "i-button",
                  {
                    props: {
                      type: "error",
                      size: "small"
                    },
                    on: {
                      click: () => {
                        this.alert.id = params.row.id;
                        this.alert.show = true;
                      }
                    }
                  },
                  "删除"
                )
              ]);
            }
          }
        ],
        tableBorder: "1px solid #CCC", // 设置边框颜色
        data: [],
        pageCurrent: 1,
        pageSize: 10,

        total: 0,
        loading: true,
        isSystem_loading: false // 切换启用状态loading
      },
      // 查询
      search: {
        manualType: null,
        startDate: null,
        endDate: null,
      },
      // 表单
      modal: {
        show: false, // 表单modal显示隐藏
        title: "添加"
      },
      // 表单数据
      formValidate: {
        manualType: null,
        monitoringDate: "",
        fluoride: null,
        pm10: null,
        sd: null,
        cam: null,
        nmhc: null,
        hcho: null,
        phen: null,
        am: null,
        odor: null,
        fluorideThanSign: 0,
        pm10ThanSign: 0,
        sdThanSign: 0,
        camThanSign: 0,
        nmhcThanSign: 0,
        hchoThanSign: 0,
        phenThanSign: 0,
        amThanSign: 0,
        odorThanSign: 0,
        content: 0,
        createDate: null,
      },
      typeItmeObj: {
        RJHDA001: ['fluoride', 'pm10'],//氟化物、颗粒物
        RJHDA002: ['fluoride', 'pm10','sd'], //氟化物、颗粒物
        RJHDA003: ['fluoride', 'pm10','cam'], //氟化物、颗粒物
        DA001: ['pm10'], //颗粒物
        DA003: ['cam'], //铬酸雾

        DA005: ['nmhc','hcho','phen','odor'], //非甲烷总烃、甲醛、苯酚、臭气浓度
        DA006: ['pm10'], //颗粒物
        DA007: ['nmhc'], //非甲烷总烃
        KS008: ['am'], //碱雾
      },
      typeNameObj: {
        fluoride: "氟化物",
        sd: "烟尘",
        pm10: "颗粒物",
        cam: " 铬酸雾",
        hcho: "甲醛",
        nmhc: "非甲烷总烃",
        phen: "苯酚(酚类化合物)",
        am: "碱雾",
        odor: "臭气浓度"
      },
      // 验证
      ruleValidate: {
        monitoringDate: [{ required: true, type: "date", message: "不能为空" }]
      },
      // alert提示组件
      alert: {
        show: false,
        loading: false,
        id: ""
      },
      manualInputType: {}, // 排口类型
      ThanSignList: [
        { name: '无', value: 0 },
        { name: '<', value: 1 },
        { name: '>', value: 2 },
        { name: '<=', value: 3 },
        { name: '>=', value: 4 },
        { name: '==', value: 5 },
        { name: '!=', value: 6 }
      ],
    };
  },
  components: {
    toolbar
  },
  created() {
    this.search.manualType = this.$route.query.mt;
    this.getManualType(); // 下拉数据初始化
    this.getData(); // 数据初始化
  },
  computed: {
    // 根据manualType计算需要显示的输入框属性数组
    visibleInputFields() {
      const selectedType = this.formValidate.manualType;
      //console.log("selectedType=" + selectedType);
      return selectedType ? this.typeItmeObj[selectedType] || [] : [];
    },
    sortedData() {
      const sorted = {};
      Object.keys(this.manualInputType)
        .sort()
        .forEach((key) => {
          sorted[key] = this.manualInputType[key];
        });
      return sorted;
    },
    sortedDataFiltered() {
      const sorted = {};
      Object.keys(this.manualInputType)
        .sort()
        .forEach((key) => {
          if (this.typeItmeObj.hasOwnProperty(key)) {
            sorted[key] = this.manualInputType[key];
          }
        });
      return sorted;
    }
  },
  methods: {
    getLabel(attribute) {
      return this.typeNameObj[attribute];
    },
    getPlaceholder(attribute) {
      return "请输入" + this.typeNameObj[attribute];
    },
    // 处理manualType改变事件
    handleManualTypeChange() {
      this.getData(); 
    },
    getManualType() {
      this.$api.Report.getDataManualInputType({ content: "" }, ["uuid", "company"]).then(res => {
        if (res.code == 0) {
          this.manualInputType = res.data;
        } else {
          this.$Notice.warning({
            title: "获取排口类型失败",
            desc: res.message || "请联系管理员"
          });
        }
      });
    },
    // 搜索
    searchFunc() {
      this.getData();
    },
    layOut() {
      var bindCompanies = JSON.parse(localStorage.getItem("bindCompanies")); // 用户企业信息
      let url = BaseUrl + "/api/company/data/manual/input/download?";
      url +=
        "content=" +
        encodeURI(
          JSON.stringify({
            uuid: bindCompanies[0].uuid,
            startDate: this.search.startDate,
            endDate: this.search.endDate,
          })
        );
      axios({
        methods: "get",
        url: url,
        withCredentials: true,
        responseType: "blob",
      })
        .then(response => {
          // 创建一个Blob对象，并通过URL.createObjectURL创建下载链接
          const url = window.URL.createObjectURL(new Blob([response.data]));

          // 创建一个<a>标签，设置下载链接和文件名，模拟点击下载
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', 'DataManualInput.xlsx');
          document.body.appendChild(link);
          link.click();

          // 释放URL对象
          window.URL.revokeObjectURL(url);
        })
        .catch(error => {
          console.error('下载失败', error);
        });
    },
    addData() {
      // 打开表单添加
      this.modal.title = "添加";
      this.modal.show = true;
      this.formValidate = {
        manualType: null,
        monitoringDate: "",
        fluoride: "",
        pm10: "",
        sd: "",
        cam: "",
        nmhc: "",
        hcho: "",
        phen: "",
        am: "",
        odor: "",
        fluorideThanSign: 0,
        pm10ThanSign: 0,
        sdThanSign: 0,
        camThanSign: 0,
        nmhcThanSign: 0,
        hchoThanSign: 0,
        phenThanSign: 0,
        amThanSign: 0,
        odorThanSign: 0,
        content: "",
      };
      this.$refs.formValidate.resetFields(); // 清除验证错误
    },
    getData() {
      // 获取数据
      this.table.loading = true;
      this.$api.Report.getDataManualInputList(
        {
          pageCurrent: this.table.pageCurrent,
          pageSize: this.table.pageSize,
          content: this.search
        },
        ["uuid", "company"]
      ).then(res => {
        if (res.code == 0) {
          // 获取成功
          this.table.data = res.data.list;
          this.table.total = res.data.total;
          this.table.loading = false;
          this.$Message.success("加载完成");
        } else {
          this.$Message.warning(res.message);
          this.table.loading = false;
        }
      });
    },
    delData() {
      // 删除数据
      let id = this.alert.id; // 点击删除时对应的id
      if (id) {
        // 删
        this.alert.loading = true;
        this.$api.Report.postDataManualInputDel({ content: { id: id } }, [
          "uuid",
          "company"
        ])
          .then(res => {
            this.alert.show = false;
            if (res.code == 0) {
              this.alert.loading = false;
              this.$Notice.success({
                title: "删除成功",
                desc: ""
              });
              this.getData();
            } else {
              this.alert.loading = false;
              this.$Notice.warning({
                title: "删除失败",
                desc: res.message || "请联系管理员"
              });
            }
          })
          .catch(err => {
            this.alert.show = false;
            this.alert.loading = false;
          });
      } else {
        // 不存在id说明异常
        this.alert.show = false;
        this.$Notice.warning({
          title: "删除失败",
          desc: "数据异常，请联系管理员"
        });
      }
    },
    pageCurrentChange(num) {
      // 页码跳转
      this.table.pageCurrent = num;
      this.getData();
    },
    pageSizeChange(num) {
      // 每页数量切换
      this.table.pageSize = num;
      this.getData();
    },
    activeData() {
      //增、改操作
      this.$refs.formValidate.validate(valid => {
        if (valid) {
          let params = this.formValidate;
          // 表单验证是否通过
          if (this.modal.title == "添加") {
            this.$api.Report.postDataManualInputAdd({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "添加成功",
                  desc: "添加成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "添加失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          } else {
            this.$api.Report.postDataManualInputEdit({ content: params }, [
              "uuid",
              "company"
            ]).then(res => {
              if (res.code == 0) {
                this.$Notice.success({
                  title: "更新成功",
                  desc: "更新成功，正在刷新数据..."
                });
                this.modal.show = false;
                this.getData();
              } else {
                this.$Notice.warning({
                  title: "更新失败",
                  desc: res.message || "请联系管理员"
                });
              }
            });
          }
        }
      });
    },
    dateSelect(date) {
      this.search.startDate = new Date(date[0]).setHours("0");
      this.search.endDate = new Date(date[1]).setHours("24");
      //console.log(this.search);
    },
    findManualTypeByName(name) {
      return Object.prototype.hasOwnProperty.call(this.manualInputType, name) ? this.manualInputType[name] : undefined;
    },
    findThanSign(id) {
      if (id == 0 || id == null) return "";
      const sign = this.ThanSignList.find((item) => item.value === id);
      return sign ? sign.name : "";
    },
    getValue(obj) {
      return obj !== undefined && obj !== null ? obj : '';
    }
  }
};
</script>